import { FormSection } from '@ksyos/design-system';
import type { OsasConsultData } from '@common/validation/customControls/osas/osasConsultSchemas/types';
import { ConclusionFormGroup } from '@frontend/components/pages/episodeCategory/customControls/osas/osasConsult/components/ConclusionFormGroup';
import {
    DateInputFormGroup,
    TextAreaFormGroup,
} from '@frontend/components/pages/episodeCategory/customControls/processActivityFormGroupFields';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { PolicyFormSection } from './components/policyFormSection/PolicyFormSection';
import { SleepStudyFindings } from './components/SleepStudyFindingsFormGroup';

export function OsasConsultEdit() {
    const { errors, data, onChange, processActivityId } = useProcessActivityEditContext<OsasConsultData>();

    return (
        <>
            <FormSection>
                <DateInputFormGroup
                    error={getDateError()}
                    fieldKey="consultDate"
                    isRequired={true}
                    label="Datum consult met de patiënt"
                />
            </FormSection>
            <FormSection title="Aanvullende specialistische bevindingen">
                <TextAreaFormGroup
                    fieldKey="additionalAnamnesis"
                    label="Aanvullende anamnese"
                    placeholder=""
                />
                <TextAreaFormGroup
                    fieldKey="additionalPhysicalExamination"
                    label="Aanvullend lichamelijk onderzoek"
                    placeholder=""
                />
            </FormSection>
            <FormSection title="Bevindingen slaaponderzoek">
                <SleepStudyFindings
                    data={data}
                    errors={errors}
                    onChange={onChange}
                    processActivityId={processActivityId}
                />
            </FormSection>

            <ConclusionFormGroup
                data={data}
                errors={errors}
                onChange={onChange}
            />

            <PolicyFormSection
                data={data}
                errors={errors}
                onChange={onChange}
            />
        </>
    );

    function getDateError() {
        if (errors.has('consultDate')) {
            if (!data.consultDate) {
                return 'any_required';
            }

            return errors.get('consultDate');
        }
    }
}
